module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAMAAABPqWaPAAAAZlBMVEUAAACampqZmZmampqZmZmbm5uqqqqZmZmZmZmdnZ2ampqampqampqampqbm5ulpaWampqZmZmampqampqcnJycnJyenp6enp6ZmZmZmZmZmZmampqampqZmZmampqdnZ2ZmZmZmZkqM1H0AAAAIXRSTlMAI3tW5UEE0WgV73RvXikM87atikg7Gw/62Ma/oJaNNDLjzs2OAAAAp0lEQVQoz23RRxKDMABDUTm4UWx6J0X3v2TYMHaC//ZtNCNEidZMSFT3C1klwEmePQAczxyheSMv6VlkOMudtVYIBsHbLAMAw7MsktFjNk0O8F8kX/DsEyI6lugafRfordCWIiGo6BWHlJQUiioh9Sq15XQXZeiwy9TqwmJkCbS31TOElDWgR6VUHgngZOHDBW2QjuaDqGG95FFp/KTLhqyQbDr26LMvYzcbkhu+vI0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/icon/sound.png
// module id = W/z3
// module chunks = 1